<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<form #df="ngForm" novalidate class="formborder" style="min-height: 6.25rem;display: flex;align-items: center;">
  <div class="row m-0 col-md-12">
    <div class="col-md-2 p-1">
      <span class="required-lable">Select Status</span>
      <select
        name="SelectStatus"
        id="SelectStatus"
        #refSelectStatus="ngModel"
        class="form-control input-text-css"
        (change)="onSelectStatusChange($event)"
        [(ngModel)]="SelectStatus"
      >
        <option value="All">All</option>
        <option value="Not Sending">Not Sending</option>
        <option value="Not Received">Not Received</option>
        <option value="Received">Received</option>
      </select>
    </div>
    <div class="col-md-2">
      <button
        type="button"
        (click)="searchSendingReceivingReport()"
        class="mt-4 btn font-size-12 button-btn"
        [disabled]="!df.form.valid"
      >
        Search
      </button>
    </div>

    <div class="float-end col-md-4 mt-2" [hidden]="!dataSource">
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input
              type="text"
              id="FilterInputSearch"
              (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch"
              placeholder="What're you searching for?"
              class="form-control border-0 bg-light"
            />
            <div class="input-group-append">
              <button
                id="button-addon1"
                type="submit"
                class="btn btn-link text-primary"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</form>
<div
  class="table-responsive mt-3"
  *ngIf="dataSource && dataSource.data && dataSource.data.length > 0"
>
 <mat-table
          matSort
          [dataSource]="dataSource"
          id="fileSendingReceivingReportTable"
          matTableExporter
          #exporter="matTableExporter"
>
    <ng-container matColumnDef="Id">
      <mat-header-cell
        mat-sort-header
        class="grid-header"
        style="max-width: 3.125rem"
        *matHeaderCellDef
      >
        #
      </mat-header-cell>
      <mat-cell *matCellDef="let row,let i = index" class="grid-cell" style="max-width: 3.125rem;max-height:0.3125rem">
          {{ (paginator.pageIndex * paginator.pageSize) + (i + 1) }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Application_No">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Application No
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Application_No }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="LoanAc_No">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Loan Ac No
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.LoanAc_No }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_Name">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Customer Name
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Customer_Name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Branch_Name">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Branch Name
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Branch_Name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Product_Name">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Product Name
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Product_Name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Loan_Amount">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Loan Amount
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Loan_Amount }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Detail">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Detail
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Detail }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Courier_By">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Courier By
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Courier_By }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="File_SendBy">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        File Send By
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.File_SendBy }}
      </mat-cell> </ng-container
    ><ng-container matColumnDef="File_sendOn">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        File Send On
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.File_sendOn }}
      </mat-cell> </ng-container
    ><ng-container matColumnDef="Sending_Remark">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Sending Remark
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Sending_Remark }}
      </mat-cell> </ng-container
    ><ng-container matColumnDef="File_ReceiveBy">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        File Receive By
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.File_ReceiveBy }}
      </mat-cell> </ng-container
    ><ng-container matColumnDef="File_ReceiveOn">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        File Receive On
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.File_ReceiveOn }}
      </mat-cell> </ng-container
    ><ng-container matColumnDef="Receive_Remarks">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Receive Remarks
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Receive_Remarks }}
      </mat-cell> </ng-container
    ><ng-container matColumnDef="File_Status">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        File Status
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.File_Status }}
      </mat-cell>
    </ng-container>

    <mat-header-row
      class="sticky-footer"
      *matHeaderRowDef="displayedSendingReceivingColumns; sticky: true"
    ></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedSendingReceivingColumns"
    ></mat-row>
  </mat-table>
  <div class="row m-0 align-items-center justify-content-between">
    <div class="col-md-4">
      <button class="mt-3 btn font-size-12 button-btn " (click)="exportTable()">
        <i
          class="fa fa-file-export mr-1"
          style="font-size: medium; cursor: pointer"
        ></i
        >Export
      </button>
    </div>
    <div class="col-md-8 text-right mt-3">
      <mat-paginator
  #paginator
  [pageSizeOptions]="[20, 50]"
  showFirstLastButtons
></mat-paginator>
    </div>
  </div>
</div>
<table
  id="fileSendingReceivingReportTablePrint"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Application No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan Ac No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Branch Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Product Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Detail
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Courier By
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      File Send By
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      File Send On
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Sending Remark
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      File Receive By
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      File Receive On
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Receive Remarks
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      File Status
    </th>
  </tr>

  <tr *ngFor="let x of dataSource.data; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Application_No }}</td>
    <td>{{ x.LoanAc_No }}</td>
    <td style="text-align: right">{{ x.Customer_Name }}</td>
    <td style="text-align: right">{{ x.Branch_Name }}</td>
    <td style="text-align: right">{{ x.Product_Name }}</td>
    <td style="text-align: right">{{ x.Loan_Amount }}</td>
    <td style="text-align: right">{{ x.Detail }}</td>
    <td style="text-align: right">{{ x.Courier_By }}</td>
    <td style="text-align: right">{{ x.File_SendBy }}</td>
    <td style="text-align: right">{{ x.File_sendOn }}</td>
    <td style="text-align: right">{{ x.Sending_Remark }}</td>
    <td style="text-align: right">{{ x.File_ReceiveBy }}</td>
    <td style="text-align: right">{{ x.File_ReceiveOn }}</td>
    <td style="text-align: right">{{ x.Receive_Remarks }}</td>
    <td style="text-align: right">{{ x.File_Status }}</td>
  </tr>
</table>
